<template>
  <div class="wallet-page">
    <!-- 标签栏 -->
    <ul class="wallet-tabs">
      <li
        v-for="tab in tabs"
        :key="tab.id"
        :class="{ active: currentTab === tab.id }"
        @click="switchTab(tab.id)"
      >
        {{ tab.label }}
      </li>
    </ul>

    <!-- 内容区 -->
    <div class="wallet-content">
      <DepositRecords v-if="currentTab === 1" />
      <BankDepositRecords v-if="currentTab === 2" />
      <WalletLogRecords v-if="currentTab === 3" />
      <AddressRecords v-if="currentTab === 4" />
      <WithdrawalRecords v-if="currentTab === 5" />
    </div>
  </div>
</template>

<script>
import BankDepositRecords from '@/components/wallet/BankDepositRecords.vue'
import DepositRecords from '@/components/wallet/DepositRecords.vue'
import WalletLogRecords from '@/components/wallet/WalletLogRecords.vue'
import AddressRecords from '@/components/wallet/AddressRecords.vue'
import WithdrawalRecords from '@/components/wallet/WithdrawalRecords.vue'

export default {
  name: 'WalletVue',
  components: {
    WalletLogRecords,
    AddressRecords,
    DepositRecords,
    WithdrawalRecords,
    BankDepositRecords
  },
  data() {
    return {
      currentTab: 1,
      tabs: [
        { id: 1, label: this.$t('_qb._cbjl') },
        { id: 2, label: this.$t('_m._yhzz') },
        { id: 3, label: this.$t('_qb._jyjl') },
        { id: 4, label: this.$t('_qb._bddz') },
        { id: 5, label: this.$t('_qb._txjl') }
      ]
    }
  },
  methods: {
    switchTab(id) {
      this.currentTab = id
    }
  }
}
</script>

<style scoped>
/* ============================================================
   钱包页面 - 暗色主题
   ============================================================ */

.wallet-page {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px 24px 40px;
  background: #0b0d0f;
  color: #e8edf2;
}

/* ============================================================
   标签栏
   ============================================================ */
.wallet-tabs {
  display: flex;
  gap: 4px;
  padding: 0 0 20px;
  margin: 0 0 24px;
  list-style: none;
  border-bottom: 1px solid #1a1f26;
  overflow-x: auto;
  flex-wrap: nowrap;
}

/* 自定义滚动条 */
.wallet-tabs::-webkit-scrollbar {
  height: 2px;
}

.wallet-tabs::-webkit-scrollbar-track {
  background: transparent;
}

.wallet-tabs::-webkit-scrollbar-thumb {
  background: #2a3138;
  border-radius: 4px;
}

.wallet-tabs li {
  flex-shrink: 0;
  padding: 10px 24px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #8a949f;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  position: relative;
}

.wallet-tabs li:hover {
  color: #e8edf2;
  background: rgba(255, 255, 255, 0.04);
}

.wallet-tabs li.active {
  color: #e8edf2;
  background: rgba(255, 152, 0, 0.12);
}

/* 底部高亮条 */
.wallet-tabs li.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  height: 3px;
  background: #ff9800;
  border-radius: 4px 4px 0 0;
}

/* ============================================================
   内容区
   ============================================================ */
.wallet-content {
  /* background: #131313; */
  border-radius: 16px;
  /* border: 1px solid #1a1f26; */
  /* padding: 20px 24px; */
  min-height: 400px;
}

/* ============================================================
   Toast 弹框覆盖（如果需要）
   ============================================================ */
.wallet-page :deep(.cx-bfet) {
  /* 继承暗色主题 */
}

.wallet-page :deep(.pp-box) {
  background: #141a20 !important;
  border: 1px solid #1e262e;
}

.wallet-page :deep(.cx-title) {
  color: #e8edf2 !important;
}

.wallet-page :deep(.cx-title[style*="color: #666"]) {
  color: #8a949f !important;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 768px) {
  .wallet-page {
    padding: 12px 12px 30px;
  }

  .wallet-tabs {
    gap: 2px;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  .wallet-tabs li {
    padding: 8px 16px;
    font-size: 13px;
  }

  .wallet-tabs li.active::after {
    width: 30%;
  }

  .wallet-content {
    padding: 14px 16px;
    border-radius: 12px;
  }
}

@media (max-width: 480px) {
  .wallet-tabs li {
    padding: 6px 12px;
    font-size: 12px;
  }

  .wallet-content {
    padding: 10px 12px;
    min-height: 300px;
  }
}
</style>

<!-- ============================================================
   原有样式保留（供子组件使用）
   ============================================================ -->
<style>
/* 保留原有样式，供子组件使用 */
.hbox {
  padding: 15px 10px;
  display: flex;
}

.hb2b {
  flex: 1;
  text-align: left;
}

.ha {
  font-size: 15px;
}

.hd {
  font-size: 15px;
}

.hw150 {
  flex: 0 0 150px;
}

.hw200 {
  flex: 0 0 200px;
}

.hwauto {
  flex: 1 1 auto;
}

.hd:nth-child(2n) {
  background: #f5f5f5;
}
</style>